import React from 'react';
import ReactDOM from 'react-dom/client';
import Homepage from './App.jsx';
import { ThemeProvider } from './theme.jsx';
import './styles.css';
import './layout.css';
import './responsive.css';
import './sections/mobile/mobile.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <ThemeProvider>
    <Homepage />
  </ThemeProvider>
);
